import { render } from "./DjActivationTab.vue?vue&type=template&id=c0cb41b0&scoped=true"
import script from "./DjActivationTab.vue?vue&type=script&lang=js"
export * from "./DjActivationTab.vue?vue&type=script&lang=js"

import "./DjActivationTab.vue?vue&type=style&index=0&id=c0cb41b0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c0cb41b0"

export default script